module.exports = __webpack_public_path__ + "static/media/bottom_sheet_icon_pan.bdbd193e.svg";